const navBarVisible = () => {
	const navbar = document.querySelector('.nav-bar')
	const body = document.querySelector('.main')
	const copyr = document.querySelector('.nav-bar__copyr')
	const menu = document.querySelector('.nav-bar__menu')
	const logo = document.querySelector('.nav-bar__logo')
	//const theme = document.querySelector('.nav-bar__theme')

	navbar.classList.toggle('nav-bar_open')
  navbar.classList.toggle('is-show')

	if (window.screen.width >= '991') {
		body.classList.toggle('main_navbar-open')
		menu.classList.toggle('nav-bar__menu_small')
		//theme.classList.toggle('nav-bar__theme_hide')
		copyr.classList.toggle('nav-bar__copyr_hide')
		logo.classList.toggle('nav-bar__logo_hide')
	}
}

const init = () => {
	const buttonHide = document.querySelector('.button-hide')

	if(buttonHide) {
		buttonHide.addEventListener('click', function () {
			if (window.screen.width >= '991') {
				this.classList.toggle('is-show')
			}
			navBarVisible()
		})
	}

}

export default {
	init,
};
